import React from 'react';
import styles from './CoreButton.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { Button } from '@/components';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreButton(props) {
	const { attributes } = props;
	const className = attributes.className?.split(' ') || [];
	const styles = formatStyles(attributes.style);

	return (
		attributes.text && (
			<div className={cx(['button-container', attributes.fontSize && `is-font-size-${attributes.fontSize}`, ...className])}>
				<Button id={attributes.anchor} className={cx([attributes.textColor && `text-color-${attributes.textColor}`, attributes.textAlign && `textAlign-${attributes.textAlign}`, ...className])} href={attributes.url} target={attributes.linkTarget} rel={attributes.rel} style={{ ...styles }}>
					{attributes.text}
				</Button>
			</div>
		)
	);
}

CoreButton.fragments = {
	key: `CoreButtonFragment`,
	entry: gql`
		fragment CoreButtonFragment on CoreButton {
			attributes {
				anchor
				className
				text
        textColor
        textAlign
				linkTarget
        fontSize
				rel
				url
				backgroundColor
				style
			}
		}
	`,
};

CoreButton.config = {
	name: 'CoreButton',
};
CoreButton.displayName = 'CoreButton';
